<!-- Global header/navbar -->
<cm-header *ngIf="isUserAuthenticated"></cm-header>

<!-- Auditing tools applications -->
<router-outlet></router-outlet>

<!-- Global footer -->
